import { onDomReady, sel, selAll } from './utils'

export default function Thank() {
  const back$ = sel('.is--back')
  back$?.addEventListener('click', () => {
    window.history.back()
  })
}
